import { useInfiniteListAuditEvents } from '@sunstone/api-client/hooks';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@sunstone/ui';
import { AuditHistory } from '@/components/ui/AuditHistory';

interface ReleaseHistorySheetProps {
  token: string | null;
  releaseId: string;
  version: string;
  onClose: () => void;
}

/**
 * Slide-over panel showing a single release's audit trail (enabled/disabled
 * toggles, deprecation, blocked deprecation attempts, sync runs). Mounted
 * only while a release's history is being viewed (see ReleasesPage), so
 * useInfiniteListAuditEvents - which has no way to stay idle once a token is
 * present - only ever queries once a specific release is selected.
 */
export function ReleaseHistorySheet({
  token,
  releaseId,
  version,
  onClose,
}: ReleaseHistorySheetProps) {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteListAuditEvents(
    token,
    'release',
    releaseId,
  );
  const events = data?.pages.flatMap((p) => p.events) ?? [];

  return (
    <Sheet open onOpenChange={(open) => !open && onClose()}>
      <SheetContent className="w-full sm:max-w-lg">
        <SheetHeader>
          <SheetTitle>History — {version}</SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto">
          <AuditHistory
            events={events}
            onLoadMore={fetchNextPage}
            hasMore={hasNextPage}
            isLoadingMore={isFetchingNextPage}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
}
